import { flow } from "fp-ts/es6/function"
import { append, applyTo, concat, join, map, partial, prop, toLower, zipObj } from "ramda"
import { useMemo } from "react"
import { useDispatch } from "react-redux"
import { bindActionCreators } from "redux"
import { createAction } from "redux-act"

import * as Data from "../data/index.js"
import { NamespaceConfig } from "../namespace/config.js"
import * as Str from "../str/index.js"

/**
 * Takes actions from the given structures and combines them
 * into the new structure where actions indexed by subdomain.
 * Each structure should have the `domain` property which have the `path` property with list type.
 * Each actions group should be an object indexed by `actions` key inside its own structure.
 *
 * @param {...object|Record} structures `Object`s or `Record`s containing actions and domains
 */
export const from = flow(
  partial(Data.mappedBy, [NamespaceConfig.subdomain.path]),
  map(prop("actions")),
)

// TODO: deprecated, replace by `of()` everywhere
/**
 * Generates a group of action creators for the given domain indexed by the given names
 * @param {string} domain
 * @param {string[]} names
 */
export const groupedBy = (domain, names) =>
  zipObj(
    names,
    map(flow(Str.fromCamelCase, toLower, concat(concat(domain, " ")), createAction), names),
  )

/**
 * Generates a group of action creators for the given domain indexed by the given names
 * @param {object} domain
 * @param {string[]} names
 */
export const of = (domain, names) =>
  zipObj(
    names,
    map(
      flow(Str.fromCamelCase, toLower, append, applyTo(domain.path), join(" "), createAction),
      names,
    ),
  )

export const useGroup = (actions) => {
  const dispatch = useDispatch()

  return useMemo(() => bindActionCreators(actions, dispatch), [actions, dispatch])
}
